// helpers/api_errors.js
export function first(arr) {
  return Array.isArray(arr) ? arr[0] : arr;
}

const DEFAULT_FIELD_LABELS = {
  email: "Correo",
  username: "Username",
  password: "Contraseña",
  password_confirmation: "Confirmación de contraseña",
  first_name: "Nombre",
  last_name: "Apellido",
  phone: "Teléfono",
};

export function humanizeFieldError(field, rawMsg) {
  const msg = String(rawMsg || "");

  // traducciones comunes (Rails/Mongoid)
  if (msg.includes("has already been taken")) return "ya está registrado.";
  if (msg.includes("is invalid")) return "no es válido.";
  if (msg.includes("can't be blank")) return "es requerido.";
  if (msg.includes("is too short")) return "es demasiado corto.";
  if (msg.includes("is too long")) return "es demasiado largo.";
  if (msg.includes("only allows letters, numbers, underscores, and hyphens")) {
    return "solo permite letras, números, guiones (-) y guiones bajos (_).";
  }

  // fallback
  return msg;
}

export function normalizeApiError(err, { fieldLabels = DEFAULT_FIELD_LABELS } = {}) {
  const data = err?.response?.data || {};

  const fieldErrors = {};
  const rawErrors = data?.errors;
  if (rawErrors && typeof rawErrors === "object" && !Array.isArray(rawErrors)) {
    Object.entries(rawErrors).forEach(([field, msgs]) => {
      const msg = first(msgs);
      const label = fieldLabels[field] || field;
      fieldErrors[field] = `${label} ${humanizeFieldError(field, msg)}`;
    });
  }

  let errorMessage = data?.message || "";

  if (!errorMessage) {
    if (typeof data?.details === "string") errorMessage = data.details;
    else if (Array.isArray(data?.details)) errorMessage = data.details.join("\n");
    else if (typeof data?.error === "string") errorMessage = data.error;
  }

  if (Object.keys(fieldErrors).length) {
    errorMessage = "Revisa los campos marcados.";
  }

  if (!errorMessage) errorMessage = "No se pudo completar el registro. Intenta de nuevo.";

  return { errorMessage, fieldErrors, raw: data };
}
